export default __webpack_public_path__ + "static/media/dp_logo.4451ce83.svg";